export const analysisConstants = {

    SELECT_PORTFOLIO_ANALYSIS: 'SELECT_PORTFOLIO_ANALYSIS',
    DESELECT_PORTFOLIO_ANALYSIS: 'DESELECT_PORTFOLIO_ANALYSIS',

    GET_PORTFOLIO_ANALYSES_LIST_REQUEST: 'GET_PORTFOLIO_ANALYSES_LIST_REQUEST',
    GET_PORTFOLIO_ANALYSES_LIST_SUCCESS: 'GET_PORTFOLIO_ANALYSES_LIST_SUCCESS',
    GET_PORTFOLIO_ANALYSES_LIST_FAILURE: 'GET_PORTFOLIO_ANALYSES_LIST_FAILURE',

    GET_PORTFOLIO_ANALYSIS_REQUEST: 'GET_PORTFOLIO_ANALYSIS_REQUEST',
    GET_PORTFOLIO_ANALYSIS_SUCCESS: 'GET_PORTFOLIO_ANALYSIS_SUCCESS',
    GET_PORTFOLIO_ANALYSIS_PENDING: 'GET_PORTFOLIO_ANALYSIS_PENDING',
    GET_PORTFOLIO_ANALYSIS_FAILURE: 'GET_PORTFOLIO_ANALYSIS_FAILURE',

    CHANGE_ANALYSIS_FILTER: 'CHANGE_ANALYSIS_FILTER',

    EDIT_PORTFOLIO_ANALYSIS_NAME_REQUEST: 'EDIT_PORTFOLIO_ANALYSIS_NAME_REQUEST',
    EDIT_PORTFOLIO_ANALYSIS_NAME_SUCCESS: 'EDIT_PORTFOLIO_ANALYSIS_NAME_SUCCESS',
    EDIT_PORTFOLIO_ANALYSIS_NAME_FAILURE: 'EDIT_PORTFOLIO_ANALYSIS_NAME_FAILURE',

    EDIT_PORTFOLIO_ANALYSIS_DESC_REQUEST: 'EDIT_PORTFOLIO_ANALYSIS_DESC_REQUEST',
    EDIT_PORTFOLIO_ANALYSIS_DESC_SUCCESS: 'EDIT_PORTFOLIO_ANALYSIS_DESC_SUCCESS',
    EDIT_PORTFOLIO_ANALYSIS_DESC_FAILURE: 'EDIT_PORTFOLIO_ANALYSIS_DESC_FAILURE',

    DELETE_PORTFOLIO_ANALYSIS_REQUEST: 'DELETE_PORTFOLIO_ANALYSIS_REQUEST',
    DELETE_PORTFOLIO_ANALYSIS_SUCCESS: 'DELETE_PORTFOLIO_ANALYSIS_SUCCESS',
    DELETE_PORTFOLIO_ANALYSIS_FAILURE: 'DELETE_PORTFOLIO_ANALYSIS_FAILURE',

    EXPORT_PORTFOLIO_ANALYSIS_REQUEST: 'EXPORT_PORTFOLIO_ANALYSIS_REQUEST',
    EXPORT_PORTFOLIO_ANALYSIS_SUCCESS: 'EXPORT_PORTFOLIO_ANALYSIS_SUCCESS',
    EXPORT_PORTFOLIO_ANALYSIS_FAILURE: 'EXPORT_PORTFOLIO_ANALYSIS_FAILURE',
};


// WEBPACK FOOTER //
// ./src/constants/analysis.constants.js